module.exports = __webpack_public_path__ + "static/media/userIcon_wh.63a85461.svg";